import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import styles from '../../device/device-info-view/device-view.module.css'
import { primaryColor, secondaryColor } from '../../../../constants'
import IntelMsg from '../../../ItelMsg'
import EditModal from './editModal'
import DeleteModal from './deleteModal'

const AssetActions = ({ onBackClick, assetData }) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  return (
    <>
      <div className={styles.actions}>
        <Button
          style={{ background: primaryColor, color: 'white' }}
          icon
          labelPosition="left"
          onClick={() => onBackClick()}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
        <div>
          <Button
            style={{ background: secondaryColor, color: 'white' }}
            icon
            color="facebook"
            labelPosition="left"
            onClick={() => setOpenEditModal(true)}
          >
            <Icon name="edit" />
            <IntelMsg id="edit" />
          </Button>
          <Button
            icon
            color="red"
            labelPosition="left"
            onClick={() => setOpenDeleteModal(true)}
          >
            <Icon name="trash" />
            <IntelMsg id="Deactivate" />
          </Button>
        </div>
      </div>
      <DeleteModal
        open={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
      />
      <EditModal
        prop={onBackClick}
        assetData={assetData}
        open={openEditModal}
        setOpenEditModal={setOpenEditModal}
      />
    </>
  )
}
AssetActions.propTypes = {
  onBackClick: Proptypes.func.isRequired,
  assetData: Proptypes.object,
}

export default AssetActions
